import { Navigate } from "react-router";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const BOUTIQUE_PATH = "/boutique/catalogue";
const REFS_SEARCH_PATH = "/boutique/recherche";
const PRODUCT_DETAIL_PATH = "/boutique/catalogue/:catalogueId/product/:refId";
const CART_PATH = "/boutique/panier";
const CHECKOUT_PATH = "/boutique/checkout";
const ORDER_CONFIRMATION_PATH = "/order/confirmation";
const ORDERS_PATH = "/boutique/commandes";
const ORDER_DETAIL_PATH = "/boutique/commandes/:id";
const PARTNERS_PATH = "/boutique/partenaires";
const PARTNER_OFFER_DETAIL_PATH = "/boutique/partenaires/:offerId";
const CAMPING_PATH = "/boutique/camping";
const CAMPING_DETAIL_PATH = "/boutique/camping/:productId";
const CAMPING_CHECKOUT_PATH = "/boutique/camping/checkout";
const TICKETING_PATH = "/boutique/billetterie";
const CADEAUX_PATH = "/boutique/cadeaux";
const CINEMA_PATH = "/boutique/cinema";
const PARCS_LOISIRS_PATH = "/boutique/parcs-loisirs";
const FITNESS_PATH = "/boutique/fitness";

const ProductDetailPage = lazyWithRetry(() => import("@/features/boutique/pages/ProductDetailPage"));
const CartPage = lazyWithRetry(() => import("@/features/cart/pages/CartPage"));
const CheckoutPage = lazyWithRetry(() => import("@/features/checkout/pages/CheckoutPage"));
const OrderConfirmationPage = lazyWithRetry(() => import("@/features/boutique/pages/OrderConfirmationPage"));
const OrdersPage = lazyWithRetry(() => import("@/features/boutique/pages/OrdersPage"));
const OrderDetailPage = lazyWithRetry(() => import("@/features/boutique/pages/OrderDetailPage"));
const RefsSearchPage = lazyWithRetry(() => import("@/features/boutique/pages/RefsSearchPage"));
const PartnersPage = lazyWithRetry(() => import("@/features/boutique/pages/PartnersPage"));
const PartnerOfferDetailPage = lazyWithRetry(() => import("@/features/boutique/pages/PartnerOfferDetailPage"));
const CampingPage = lazyWithRetry(() => import("@/features/boutique/pages/CampingPage"));
const CampingDetailPage = lazyWithRetry(() => import("@/features/boutique/pages/CampingDetailPage"));
const CampingCheckoutPage = lazyWithRetry(() => import("@/features/boutique/pages/CampingCheckoutPage"));
const TicketingPage = lazyWithRetry(() => import("@/features/boutique/pages/TicketingPage"));
const CadeauxPage = lazyWithRetry(() => import("@/features/boutique/pages/CadeauxPage"));
const CinemaPage = lazyWithRetry(() => import("@/features/boutique/pages/CinemaPage"));
const ParcsLoisirsPage = lazyWithRetry(() => import("@/features/boutique/pages/ParcsLoisirsPage"));
const FitnessPage = lazyWithRetry(() => import("@/features/boutique/pages/FitnessPage"));

const boutiqueRoutes: RouteConfig[] = [
  {
    path: BOUTIQUE_PATH,
    element: <Navigate to="/boutique" replace />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: REFS_SEARCH_PATH,
    element: <RefsSearchPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PRODUCT_DETAIL_PATH,
    element: <ProductDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CART_PATH,
    element: <CartPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CHECKOUT_PATH,
    element: <CheckoutPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: ORDER_CONFIRMATION_PATH,
    element: <OrderConfirmationPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: ORDERS_PATH,
    element: <OrdersPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: ORDER_DETAIL_PATH,
    element: <OrderDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PARTNERS_PATH,
    element: <PartnersPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PARTNER_OFFER_DETAIL_PATH,
    element: <PartnerOfferDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CAMPING_PATH,
    element: <CampingPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CAMPING_DETAIL_PATH,
    element: <CampingDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CAMPING_CHECKOUT_PATH,
    element: <CampingCheckoutPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: TICKETING_PATH,
    element: <TicketingPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CADEAUX_PATH,
    element: <CadeauxPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CINEMA_PATH,
    element: <CinemaPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PARCS_LOISIRS_PATH,
    element: <ParcsLoisirsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: FITNESS_PATH,
    element: <FitnessPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default boutiqueRoutes;
export {
  BOUTIQUE_PATH,
  ORDERS_PATH,
  REFS_SEARCH_PATH,
  PARTNERS_PATH,
  PARTNER_OFFER_DETAIL_PATH,
  CAMPING_PATH,
  CAMPING_DETAIL_PATH,
  CAMPING_CHECKOUT_PATH,
  TICKETING_PATH,
  CADEAUX_PATH,
  CINEMA_PATH,
  PARCS_LOISIRS_PATH,
  FITNESS_PATH,
};
